export default __webpack_public_path__ + "static/media/tabby-plan-published.53681b77.png";